import React, { useState } from 'react';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { postApi } from '../Services/apiService';
import {
  SELECT_FAMILY_SIDE_MODAL_DONE_SESSION_KEY,
  FAMILY_SIDE_MODAL_SESSION_USER_ID_KEY,
} from '../Utils/importTreeSideLock';
import { SNOOZE_KEY as PWA_INSTALL_SNOOZE_KEY } from '../Utils/pwaInstall';
import { clearAppBadge } from '../Utils/appBadge';
import { removePushToken } from '../Services/pushNotifications';

function LogoutModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);

    try {
      // Needs the auth token and the stored FCM token, so before anything is cleared
      await removePushToken();

      try {
        await postApi('/auth/logout', {});
      } catch (err) {
        console.error('Logout API failed:', err);
      }

      // Clear all authentication data. The install-prompt snooze is not auth
      // data - restore it so logging out doesn't re-ask to install the app.
      const pwaInstallSnooze = localStorage.getItem(PWA_INSTALL_SNOOZE_KEY);
      localStorage.removeItem('userDetail');
      localStorage.removeItem('token');
      localStorage.clear();
      if (pwaInstallSnooze) localStorage.setItem(PWA_INSTALL_SNOOZE_KEY, pwaInstallSnooze);

      // No unread notifications to show on the home-screen icon once logged out
      clearAppBadge();
      try {
        sessionStorage.removeItem(SELECT_FAMILY_SIDE_MODAL_DONE_SESSION_KEY);
        sessionStorage.removeItem(FAMILY_SIDE_MODAL_SESSION_USER_ID_KEY);
      } catch (_) {
        /* ignore */
      }

      // Show success message
      toast.success('Logged out successfully!');

      // Close modal and redirect after a short delay
      setTimeout(() => {
        setIsLoggingOut(false);
        onClose();
        navigate('/');
      }, 1000);
    } catch (error) {
      console.error('Error during logout:', error);
      toast.error('Error during logout. Please try again.');
      setIsLoggingOut(false);
    }
  };

  const customStyles = {
    content: {
      position: 'relative',
      inset: 'auto',
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      transform: 'none',
      border: 'none',
      background: 'transparent',
      padding: '0',
      maxWidth: 'calc(100vw - 32px)',
      width: 'min(455px, calc(100vw - 32px))',
      boxSizing: 'border-box',
      margin: '0',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px',
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      portalClassName="logOut"
      contentLabel="Logout Confirmation"
      ariaHideApp={false}
    >
      <div className="modal-content">
        <div className="modal-header">
          <div className=''>
            <span>
              <img src='/assets/images/logout.svg' alt=''/>
            </span>
          <button
            type="button"
            className="close"
            onClick={onClose}
            aria-label="Close"
          >
            <img src='/assets/images/close.svg' alt=''/>
          </button>
          </div>
         
      
        </div>
        <div className="modal-body">
           <h5 className="modal-body-hading">Logout</h5>
          <p className='modal-peragrapgh'>Are you sure you want to log out of your account?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-block"
            onClick={handleLogout}
            disabled={isLoggingOut}
          >
            {isLoggingOut ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Logging out...
              </>
            ) : (
              'Logout'
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default LogoutModal;
